import { AudioManager } from "../../../../audio/AudioManager";
import { ButtonOptions } from "./ButtonOptions";
import { ScaleUpButton } from "./ScaleUpButton";

export class ScaleUpCallableAnimationButton extends ScaleUpButton {
    private isCalled: boolean;
    public constructor(
        options: ButtonOptions,
        audioManager: AudioManager
    ) {
        super(options, audioManager);
        this.isCalled = false;
    }

    public async playAnimation(): Promise<void> {
        this.isCalled = true;
        this.resetAnimation();
        this.initHoverAnimation();
        await this.hoverAnimation.play();
    }

    protected override handleUp(): void {
        super.handleUp();
        this.stopAnimation();
    }

    protected override handleOut(): void {
        if (this.isCalled){
            this.playAnimation();
        } else {
            this.resetAnimation();
        }
    }

    protected override handlePointerLeave(): void {
        if (this.isCalled){
            this.playAnimation();
        } else {
            this.resetAnimation();
        }
    }

    public stopAnimation(): void {
        this.resetAnimation();
        this.isCalled = false;
    }
}